function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "apple",
  d: "M13.623,10.627a4.526,4.526,0,0,1,2.159-3.808,4.668,4.668,0,0,0-3.657-1.982c-1.557-.158-3.039.917-3.83.917s-2.008-.894-3.3-.87A4.891,4.891,0,0,0,.86,7.39C-.9,10.45.408,14.985,2.127,17.467c.84,1.215,1.842,2.58,3.157,2.53,1.266-.05,1.745-.819,3.276-.819s1.962.82,3.3.8c1.363-.026,2.226-1.239,3.06-2.457a11.059,11.059,0,0,0,1.386-2.845,4.415,4.415,0,0,1-2.684-4.045ZM11.105,3.194A4.406,4.406,0,0,0,12.145,0,4.479,4.479,0,0,0,9.2,1.515,4.192,4.192,0,0,0,8.138,4.609,3.709,3.709,0,0,0,11.1,3.194Z",
  transform: "translate(-0.022)",
  fill: "#fff"
});

function SvgIcHabitApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.286,
    height: 19.998,
    viewBox: "0 0 16.286 19.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHabitApple);
export default ForwardRef;